export default function PageTitle({ title }) {
  return (
    <>
      <div className="mb-6 border-b-2 border-coastal-200 px-6 text-coastal-800">
        <h1 className="font-bold text-3xl py-2 mb-0">{title}</h1>
        <div className="h-1 w-20 rounded-lg bg-coastal-600"></div>
      </div>
    </>
  );
}
